<div class="jasper-reports-container">
  <mat-card class="reports-card">
    <mat-card-header>
      <mat-card-title>Generate Jasper Reports</mat-card-title>
      <mat-card-subtitle>Select a report type and optional filters to generate your report</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="reportForm">
        <!-- Report Type Selection -->
        <div class="form-section">
          <h3>Report Type</h3>
          <div class="report-type-grid">
            <mat-card 
              *ngFor="let report of reportTypes" 
              class="report-type-card"
              [class.selected]="selectedReportType === report.value"
              (click)="onReportTypeChange(report.value)">
              <mat-icon>description</mat-icon>
              <span>{{ report.label }}</span>
            </mat-card>
          </div>
        </div>

        <!-- Date Range Filters (Optional) -->
        <div class="form-section">
          <h3>Optional Filters</h3>
          <div class="date-range">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Start Date</mat-label>
              <input 
                matInput 
                [matDatepicker]="startDatePicker" 
                formControlName="startDate"
                placeholder="Select start date">
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>End Date</mat-label>
              <input 
                matInput 
                [matDatepicker]="endDatePicker" 
                formControlName="endDate"
                placeholder="Select end date">
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="form-actions">
          <button 
            mat-raised-button 
            color="primary" 
            (click)="generateReport()"
            [disabled]="isLoading">
            <mat-icon *ngIf="!isLoading">download</mat-icon>
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
            {{ isLoading ? 'Generating...' : 'Generate Report' }}
          </button>

          <button 
            mat-stroked-button 
            (click)="clearForm()"
            [disabled]="isLoading">
            Clear
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Information Card -->
  <mat-card class="info-card">
    <mat-card-header>
      <mat-card-title>About Reports</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ul>
        <li><strong>Complaints Summary:</strong> Overall summary of all complaints</li>
        <li><strong>Complaints by Zones:</strong> Breakdown of complaints by geographic zones</li>
        <li><strong>Job Card Reports:</strong> Employee-wise and location-wise job card analysis</li>
        <li><strong>Location Report:</strong> Detailed report of all locations</li>
        <li><strong>User Reports:</strong> User login and registration statistics</li>
        <li><strong>Survey Report:</strong> Summary of survey data</li>
      </ul>
    </mat-card-content>
  </mat-card>
</div>

